import { render, staticRenderFns } from "./TomHornFreespins.vue?vue&type=template&id=ce1be008&"
import script from "./TomHornFreespins.vue?vue&type=script&lang=js&"
export * from "./TomHornFreespins.vue?vue&type=script&lang=js&"
import style0 from "./TomHornFreespins.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports